const baseURL = {
    URL: 'https://yesmls.com/yes100/api',

}

export default baseURL;